export enum EStairType {
  Up,
  Down,
}
